<template>
  <div class="main-content-container overflow-hidden">
    <PageTitle pageTitle="Crear Empresa/Institución" />

    <CreateCompany />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import PageTitle from "@/components/Common/PageTitle.vue"; 
import CreateCompany from "@/components/Pages/Admin/Companies/view.vue";

export default defineComponent({
  name: "CreateCompanyPage",
  components: {
    PageTitle,
    CreateCompany,
  },
});
</script>
